var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      style: { paddingTop: _vm.showGuide ? "1.866667rem" : "0" },
      attrs: { id: "app" },
    },
    [
      _vm.showGuide ? _c("common-header") : _vm._e(),
      _c(
        "van-popup",
        {
          staticClass: "srcreen",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c("div", { staticClass: "first-img" }, [
            _c("div"),
            _c("div", [
              _c("img", {
                staticClass: "close-icon",
                attrs: { src: require("@/assets/scrrenClose.png"), alt: "" },
                on: { click: _vm.to },
              }),
            ]),
          ]),
          _c("div", { staticClass: "title" }, [
            _c("div", { staticClass: "header-asa" }, [
              _c("span", { staticClass: "span" }, [
                _vm._v("Your screen is detected to be rotating"),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "screen-content" }, [
            _c("p", [_vm._v('Please turn on "Portrait Orientation Lock"')]),
            _c("div", { staticClass: "other" }, [
              _c("img", {
                staticClass: "screen",
                attrs: { src: require("@/assets/mask.png"), alt: "" },
              }),
              _c("span", [
                _vm._v("in the Control Center before taking a photo."),
              ]),
            ]),
          ]),
          _c(
            "common-btn",
            { staticClass: "consult", attrs: { click: _vm.to } },
            [_vm._v("Consult The Index")]
          ),
        ],
        1
      ),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }